import React from "react";

import { Autocomplete } from "@material-ui/lab";
import { Controller } from "react-hook-form";
import { TextField } from "@material-ui/core";

const AutocompleteControlled = ({
  options,
  name,
  label,
  control,
  size="small",
  disabled = false
}) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, value }, fieldState }) => {
        return (
          <Autocomplete
            options={options}
            disabled={disabled}
            getOptionSelected={(option, value) => option.id === value.id}
            getOptionLabel={option => option.label}
            value={value || null}
            renderInput={params => (
              <TextField
                {...params}
                size={size}
                label={label}
                variant="outlined"
                error={!!fieldState.error}
                helperText={fieldState.error ? fieldState.error.message : null}
              />
            )}
            onChange={(e, data) => onChange(data)}
            fullWidth
          />
        );
      }}
    />
  );
};

export default React.memo(AutocompleteControlled);
